import React, { MouseEvent, useCallback } from 'react';
import { toJS } from 'mobx';
import { Link } from 'react-router-dom';
import { OrdersRatingItem } from '../../types';
import Text, { TEXT } from '~/view/components/Text/Text';
import { SCREENS } from '~/constants/screens';
import './style.scss';
import { history } from '~/services/history';
import { historyPushWithSaveBackPath } from '~/helpers';

interface OrdersRatingListRowProps {
  data: OrdersRatingItem;
}

const OrdersRatingListRow = ({ data }: OrdersRatingListRowProps) => {
  const handleClick = useCallback((e: MouseEvent<HTMLElement, globalThis.MouseEvent>) => {
    // @ts-ignore
    if (e.target.localName !== 'a') {
      history.push(SCREENS.ORDER_RATING(data.id), toJS(data));
    }
  }, []);

  const [orderCreationDate, orderCreationTime] = data.createdAt.split(',');
  const [orderRatingDate, orderRatingTime] = data.commentCreatedAt.split(',');

  const handleOpenProfile: React.MouseEventHandler<HTMLAnchorElement> = useCallback((e) => {
    e.preventDefault();
    historyPushWithSaveBackPath(SCREENS.CRM_PROFILE_EDIT(data.userId));
  }, []);

  return (
    <div onClick={handleClick} className="orders-rating-list-row orders-rating-list-row__grid-template mr-4">
      <div className="orders-rating-list-row__element">
        {data.userIsDeleted ? (
          <Text dir="ltr" type={TEXT.LIST_ROW} text="deleted" />
        ) : (
          <Link onClick={handleOpenProfile} to="#" className="color-mainblue text-size-16 family-medium">
            {data.userPhone}
          </Link>
        )}
      </div>
      <div className="orders-rating-list-row__element">
        <Link to={SCREENS.ORDER_RATING_ORDER(data.orderId)} className="color-mainblue text-size-16 family-medium">
          {data.orderKey}
        </Link>
      </div>
      <div className="orders-rating-list-row__element orders-rating-list-row__dates">
        <Text dir="ltr" type={TEXT.LIST_ROW} text={`${orderCreationDate},`} noTranslate />
        <Text dir="ltr" type={TEXT.LIST_ROW} text={orderCreationTime} noTranslate />
      </div>
      <div className="orders-rating-list-row__element orders-rating-list-row__dates">
        <Text dir="ltr" type={TEXT.LIST_ROW} text={`${orderRatingDate},`} noTranslate />
        <Text dir="ltr" type={TEXT.LIST_ROW} text={orderRatingTime} noTranslate />
      </div>
      <div className="orders-rating-list-row__element">
        <Text dir="ltr" type={TEXT.LIST_ROW} text={data.branchName} noTranslate />
      </div>
      <div className="orders-rating-list-row__element">
        <Text dir="ltr" type={TEXT.LIST_ROW} text={data.meal} noTranslate />
      </div>
      <div className="orders-rating-list-row__element">
        <Text dir="ltr" type={TEXT.LIST_ROW} text={data.service} noTranslate />
      </div>
      <div className="orders-rating-list-row__element">
        <Text dir="ltr" type={TEXT.LIST_ROW} text={data.overall} noTranslate />
      </div>
      <div className="orders-rating-list-row__element">
        <Text dir="ltr" type={TEXT.LIST_ROW} text={data.average} noTranslate />
      </div>
      <div className="orders-rating-list-row__element">
        <Text dir="ltr" type={TEXT.LIST_ROW} text={data.comment} noTranslate />
      </div>
    </div>
  );
};

export default OrdersRatingListRow;
